import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { MRT_RowSelectionState } from "material-react-table";

import { InitiativeListItemDTO } from "api";
import { useGetInitiatives, useDeleteInitiatives } from "hooks";
import { BulkActionsToolbar, CustomMaterialTable } from "components";
import { TrashIcon } from "assets";

import { INITIATIVES_PAGE } from "../../consts";
import { getInitiativesColumns } from "./columns";

export const InitiativesTable = () => {
    const navigate = useNavigate();
    const { data, isLoading } = useGetInitiatives();
    const { mutate: deleteInitiatives } = useDeleteInitiatives();
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

    const selectedIds = Object.keys(rowSelection).map(Number);
    const selectedCount = selectedIds.length;
    const totalRows = data?.length ?? 0;

    const handleDelete = (id: number) => {
        deleteInitiatives([id]);
    };

    const handleBulkDelete = () => {
        deleteInitiatives(selectedIds, {
            onSuccess: () => setRowSelection({} as MRT_RowSelectionState),
        });
    };

    const handleRowClick = (row: InitiativeListItemDTO) => {
        navigate(`${INITIATIVES_PAGE.ABSOLUTE_PATH}/${row.id}`);
    };

    const columns = getInitiativesColumns(handleDelete);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
            {selectedCount > 0 && (
                <BulkActionsToolbar
                    totalSelectedRows={selectedCount}
                    totalRows={totalRows}
                    bulkActionsButtons={
                        <Button
                            variant="contained"
                            color="error"
                            startIcon={<TrashIcon />}
                            onClick={handleBulkDelete}
                            size="small"
                        >
                            Delete
                        </Button>
                    }
                />
            )}
            <CustomMaterialTable<InitiativeListItemDTO>
                data={data ?? []}
                columns={columns}
                showLoadingWhenNoData={isLoading}
                enableColumnResizing
                enableRowSelection
                onRowSelectionChange={setRowSelection}
                state={{ rowSelection }}
                getRowId={(row) => String(row.id)}
                rowClickable
                muiTableBodyRowProps={({ row }) => ({
                    onClick: () => handleRowClick(row.original),
                })}
                containerSx={{
                    flex: 1,
                    minHeight: 0,
                    width: "calc(100vw - 145px)",
                    overflowY: "auto",
                }}
            />
        </Box>
    );
};
